
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import _ from 'lodash';
import {ElForm} from "element-ui/types/form";
import {getReconciliationAllocateDetail, itemList, pagePaymentVoucher, reconcile} from "@/api/invoice/index";
import {constParser} from "@/filters";
import {INVOICE_TYPE} from "@/constant";
import {Decimal} from 'decimal.js';

@Component({
  name: 'ReconciliationInvoice',
  components: {Pagination}
})
export default class ReconciliationInvoice extends Vue {

  private showDialog = false;
  private loading0 = false;
  private loading = false;
  private options = {
    title: "",
    id: "",
    supplierId: "",
    amount:0,
    company: "",
  }
  private list = [
    {
      label: "销售方名称",
      prop: "factoryName",
      key: "factoryName",
      span: 4
    },
    {
      label: "发票总金额",
      prop: "amount",
      key: "amount"
    },
    {
      label: "发票类型",
      prop: "type",
      key: "type"
    },
    {
      label: "已核销金额",
      prop: "reconcileAmount",
      key: "reconcileAmount"
    },
    {
      label: "本次核销金额",
      prop: "unAllocateAmount",
      key: "unAllocateAmount"
    },
  ];
  private readForm = {
    factoryName: "",
    amount: 0,
    type: "",
    reconcileAmount: 0,
    unAllocateAmount: 0
  }
  //项目名称	单位	数量	单价	金额	税率	税额	总金额
  private tableCol0 = [
    {
      label: "项目名称",
      prop: "projectName",
      key: "projectName"
    },
    {
      label: "数量",
      prop: "num",
      key: "num"
    },
    {
      label: "单位",
      prop: "unit",
      key: "unit"
    },
    {
      label: "金额",
      prop: "price",
      key: "price"
    },
    {
      label: "税率",
      prop: "taxRate",
      key: "taxRate"
    },
    {
      label: "税额",
      prop: "taxAmount",
      key: "taxAmount"
    },
    {
      label: "总金额",
      prop: "amount",
      key: "amount",
    }
  ]
  //付款单号	产品品名	产品数量	单位	付款单金额	已核销付款金额	本次付款核销
  private tableCol = [
    {
      label: "付款单号",
      prop: "receiptCode",
      key: "receiptCode",
    },
    {
      label: "产品品名",
      prop: "productName",
      key: "productName",
      render: (prop, row) => {
        return row.extMap?.productName
      }
    },
    {
      label: "产品数量",
      prop: "num",
      key: "num",
      render: (prop, row) => {
        return row.extMap?.num
      }
    },
    {
      label: "单位",
      prop: "unit",
      key: "unit",
      render: (prop, row) => {
        return row.extMap?.unit
      }
    },
    {
      label: "付款单金额",
      prop: "amount",
      key: "amount",
    },
    {
      label: "已核销付款金额",
      prop: "totalAllocateAmount",
      key: "totalAllocateAmount",
    },
    {
      label: "本次分配金额",
      prop: "allocateAmount",
      key: "allocateAmount",
      type: "inputNumber",
      precision: 2,
      maxProp: "maxProp",
      width: 120,
      check: {
        prefix: "list",
        rules: [
          {
            required: true,
            message: '请输入本次分配金额',
            trigger: 'blur'
          },
          // 不能小于等于0
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('不能小于等于0'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          type: "delete",
          code: "",
          click: "handleRemove",
        },
        {
          name: "查看付款单明细",
          code: "",
          click: "handlePv",
        }
      ],
      width: 120,
    }
  ]
  private table0 = {
    list: [] as any[],
  };
  private table = {
    list: [] as any[],
  };

  private selectLoading = false;
  private selectInvoice = null;
  private invoiceOptions = []
  private selectPage = {
    pageNumber: 1,
    pageSize: 10,
    pagerCount: 5,
    total: 0,
  };
  private selectQuery = ''

  public remoteMethod = _.debounce(this.remoteMethod0, 1000);

  public remoteMethod0(query) {
    this.selectLoading = true;
    if (this.selectQuery != query) {
      this.selectPage.pageNumber = 1;
      this.selectQuery = query;
    }
    const param = {
      code: this.selectQuery,
      supplierId: this.options.supplierId,
      company: this.options.company};
    const page = {...this.selectPage};
    pagePaymentVoucher(param, page)
        .then((res) => {
          const data = res.list;
          this.invoiceOptions = data.filter(item => {
            return this.table.list.find(i => i.receiptId === item.id) === undefined
          }).map(item => {
            let label = '';
            if (!item.projectNames) {
              label = `${item.code} | 未核销金额 ${item.unAllocateAmount}元`
            } else if (item.projectNames.length <= 3) {
              label = `${item.code} ${item.projectNames.slice(0, 3).join(',')} | 未核销金额 ${item.unAllocateAmount}元`
            } else {
              label = `${item.code} ${item.projectNames.slice(0, 3).join(',') + "等"} | 未核销金额 ${item.unAllocateAmount}元`
            }
            return {
              id: item.id,
              receiptId: item.id,
              label: label,
              receiptCode: item.code,
              supplierId: item.supplierId,
              type: "PAYMENT_VOUCHER",
              amount: item.paymentAmount,
              totalAllocateAmount: new Decimal(item.paymentAmount).sub(new Decimal(item.unAllocateAmount)).toNumber(),
              allocateAmount: item.unAllocateAmount,
              maxProp: item.unAllocateAmount,
              extMap: {
                num: item.quantity,
                unit: item.units?.join(","),
                productName: item.projectNames?.join(","),
                relationPurchaseOrder: item.relationPurchaseOrder,
                relationPackingList: item.relationPackingList,
              }
            }
          })
          this.selectPage.total = Number(res.total);
        })
        .finally(() => this.selectLoading = false)
  }

  public changeSelectPage(val) {
    this.selectPage.pageNumber = val
    this.remoteMethod(this.selectQuery)
  }

  private async getList(id) {
    getReconciliationAllocateDetail({id, allocate: true})
        .then(({data}) => {
          let decimal = new Decimal(0);
          this.table.list = (data as any[]).map(item => {
            item.maxProp = new Decimal(item.amount).add(new Decimal(item.allocateAmount))
                .sub(new Decimal(item.totalAllocateAmount)).toNumber();
            decimal = decimal.add(new Decimal(item.allocateAmount))
            return item;
          })
          this.readForm.unAllocateAmount = decimal.toNumber();
          this.loading = false;
        })
  }

  public handleAddInvoice() {
    if (this.table.list.find(item => item.receiptId == this.selectInvoice) === undefined) {
      const obj = Object.assign({}, this.invoiceOptions.find(item => item.id === this.selectInvoice))
      if (obj ) {
        let totalAllocateAmount = new Decimal(0);
        this.table.list.forEach(i => {
          totalAllocateAmount = totalAllocateAmount.add(new Decimal(i.allocateAmount))
        })
        obj.allocateAmount = Math.min(obj.allocateAmount, new Decimal(this.options.amount).sub(totalAllocateAmount).toNumber())
        this.table.list.push(obj)
        this.handleInputChange()
      }
    }
  }

  public handleRemove({row}) {
    this.table.list = this.table.list.filter(item => item.receiptId !== row.receiptId)
    this.handleInputChange()
  }

  public handleUpdate({row}) {
    row["_disabled"] = false;
  }

  public handlePv({row}) {
    this.$router.push({
      name: "paymentOrderDetails",
      query: {
        id: row.receiptId
      }
    })
  }

  public handleInputChange() {
    let decimal = new Decimal(0);
    this.table.list.forEach(item => {
      decimal = decimal.add(new Decimal(item.allocateAmount))
      return item;
    })
    this.readForm.unAllocateAmount = decimal.toNumber();
  }

  public confirmLoading = false;

  public handleSubmit() {
    this.confirmLoading = true;
    (this.$refs.form as ElForm).validate(async (valid) => {
      try {
        if (valid) {
          await reconcile({
            id: this.options.id,
            allocates: this.table.list,
          });
          this.showDialog = false;
          this.$emit("confirm")
        }
      } finally {
        this.confirmLoading = false
      }
    })
  }

  public async getInvoiceItem(id) {
    this.loading0 = true;
    itemList({id}).then(({data}) => {
      this.table0.list = data as any;
      this.loading0 = false;
    })
  }

  public initReadForm(obj) {
    this.readForm.factoryName = obj.factoryName;
    this.readForm.amount = obj.amount;
    this.readForm.type = constParser(obj.type, INVOICE_TYPE);
    this.readForm.reconcileAmount = obj.reconcileAmount;
    this.invoiceOptions = []
    this.selectInvoice = null;
  }

  public async openDialog(obj, options) {
    this.options = options;
    this.options.id = obj.id;
    this.options.supplierId = obj.factoryId;
    this.options.amount = obj.amount;
    this.options.company = obj.company;
    this.showDialog = true;
    this.getList(obj.id)
    this.getInvoiceItem(obj.id)
    this.initReadForm(obj)
  }
}
